import Modal from "components/foundation/Modal/Modal";
import CardLayout from "components/foundation/templates/CardLayout";
import styled, { css } from "styled-components";

export const CardLayoutStyle = styled(CardLayout.Container)`
  ${({ theme }) => css`
    ${theme.media.notSmall} {
      width: 49.4rem;
      margin-top: 10.4rem;
    }
  `}
`;

export const ConsentFormBodyStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      gap: 2.4rem;
    }
  `}
`;

export const ConsentListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const ConsentActionsStyle = styled.div`
  margin-top: 1rem;

  display: flex;
  justify-content: flex-end;
`;

/* ==================== 모달 ==================== */
export const TermOfUseModalStyle = styled(Modal.Body)`
  width: 64rem;
  white-space: pre-wrap;
  h2 {
    text-align: center;
  }

  ${({ theme }) => theme.media.small} {
    width: unset;
    max-height: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    transform: none;

    button {
      width: 100%;
    }
  }
`;

export const ModalContentSkeletonWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
